import { MutationTree } from "vuex";
import { RootState } from "./types";

export const mutations: MutationTree<RootState> = {
  mutationLocale(state, payload: string) {
    state.locale = payload;
  },
  mutationLayout(state, payload: string) {
    state.layout = payload;
  },
};
